import type { LocalizedText } from "../registration/layoutHandles.ts";
import { useLocalizedText } from "./useLocalizedText.ts";

export function NavigationItemLabel(props: LocalizedText) {
    return useLocalizedText(props);
}
